module.exports = __webpack_public_path__ + "img/returns-reason.adb486f3.svg";